<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div id="menu-error" class="menu menu-box-modal rounded-m" 
      data-menu-height="400"
      data-menu-width="310">
    <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-times color-red-dark"></i></h1>
    <h1 class="text-center mt-3 font-700">Chyba!</h1>
    <p id="error_text" class="boxed-text-l" style="overflow: scroll; height: 140px;">
      {{ modelValue }}
    </p>
    <a href="#" class="close-menu btn btn-m btn-center-m button-s shadow-l rounded-s text-uppercase font-900 bg-red-light">KOPÍROVAŤ</a>
    <!-- <script>
      function copy_data(containerid) {
        var range = document.createRange();
        range.selectNode(containerid); //changed here
        window.getSelection().removeAllRanges(); 
        window.getSelection().addRange(range); 
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
      }
    </script> -->
  </div>
</template>

<script>
export default {
  name: 'ErrorModal',
  model: {
    prop: 'modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: 'Neznáma chyba'
    }
  },
  setup() {
    
  },
}
</script>

<style>

</style>